import { render, staticRenderFns } from "./ButtonChangePosition.vue?vue&type=template&id=3e5d1fde&scoped=true"
import script from "./ButtonChangePosition.vue?vue&type=script&lang=js"
export * from "./ButtonChangePosition.vue?vue&type=script&lang=js"
import style0 from "./ButtonChangePosition.vue?vue&type=style&index=0&id=3e5d1fde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e5d1fde",
  null
  
)

export default component.exports